export default "__VITE_ASSET__CgmiWXZR__"